import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import ComponentCustomModal from "../../../components/common/customModal/ComponentCustomModal";
import { Form, Formik } from "formik";
import { FtextField } from "../../../components/common/FtextField";
import Loader from "../../../components/common/Loader";
import { sendMikroTikBackupEmail } from "../../../features/apiCalls";

const MikrotikBackup = ({ show, setShow, mikrotik }) => {
  const { t } = useTranslation();

  //---> Local State
  const [isLoading, setIsLoading] = useState(false);

  const handleSendMikroTikBackupEmail = (formValues) => {
    const sendingData = {
      ...formValues,
      username: mikrotik?.username,
      password: mikrotik?.password,
      host: mikrotik?.host,
      port: mikrotik?.port,
      emailFrom: "zibnul1@gmail.com",
      emailPassword: "zwejqlgejyqkqqaq",
    };

    sendMikroTikBackupEmail(sendingData, setIsLoading, setShow);
  };

  return (
    <>
      <ComponentCustomModal show={show} setShow={setShow} centered={true}>
        <Formik
          initialValues={{
            emailTo: "",
          }}
          //   validationSchema={mikrotikValidator}
          onSubmit={(values) => {
            handleSendMikroTikBackupEmail(values);
          }}
          enableReinitialize
        >
          {() => (
            <Form>
              <div className="displayGrid">
                <FtextField
                  type="text"
                  label={t("enterYourEmail")}
                  name="emailTo"
                />
              </div>

              <div className="displayGrid1 float-end mt-4">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setShow(false)}
                >
                  {t("cancel")}
                </button>
                <button type="submit" className="btn btn-success">
                  {isLoading ? <Loader /> : t("submit")}
                </button>
              </div>
            </Form>
          )}
        </Formik>
      </ComponentCustomModal>
    </>
  );
};

export default MikrotikBackup;
